import React from "react";
import Animacion from "./animacion";
import { StickyContainer, Sticky } from "react-sticky";
import { Link as Boton } from "react-router-dom";
import Container from "./styled";
// Utils
import { goToTop } from "../../../utils/scrollToTop";

export default function Confirmacion() {

  return (
    <Container>
      {/* Max Width Container */}
      <div id="max-width-container">
        <div id="formulario-container">
          <h3 className="opacidad05">¡Recibimos tu mensaje con éxito!</h3>
          <p className="opacidad05" id="completa">
            Te estaremos contactando lo antes posible.
          </p>
          <Animacion></Animacion>
        </div>
        <StickyContainer>
          <Sticky>
            {({ style }) => (
              <div id="plazos-container" className="opacidad05" style={style}>
                <p>Dirección:</p>
                <p id="plazos-texto">Suipacha 245 1° Piso, CABA.</p>
                <div>
                  <p>Teléfonos</p>
                  <p id="plazos-texto">
                    0810-220-2373<br></br>(011) 5263-2373
                  </p>
                </div>
                <div>
                  <p>Email</p>
                  <p id="plazos-texto">info@seguromotos.com.ar</p>
                </div>
                <div>
                  <p>Ver más</p>
                  <Boton to="/forma-parte" onClick={goToTop}>
                    Forma parte
                  </Boton>
                  <Boton to="/sobre-nosotros">Sobre nosotros</Boton>
                </div>
              </div>
            )}
          </Sticky>
        </StickyContainer>
      </div>
    </Container>
  );
}
